import axios from 'axios';

/** ----------------------------------------
    Form
 ---------------------------------------- */

export class Form {

    constructor(el) {
        this.el = el;

        if (!this.el) return;

        this.action = this.el.dataset.action;
        this.key = this.el.dataset.key;
        this.url = this.el.action;
        this.fileInputEl = this.el.querySelector('input[type="file"]');
        this.fileErrorEl = this.el.querySelector('.js-file-error');
        this.fields = this.el.querySelectorAll('input, textarea, select');
        this.buttons = this.el.querySelectorAll('input[type="submit"], button');
        this.errorClass = 'form-block__error';
        this.fileSize = 0;
        this.maxFileSize = 10;

        this.init();
    }

    /** ----------------------------------------
        Callback setters
     ---------------------------------------- */

    set success(fn) {
        this.successCallback = fn;
    }

    set error(fn) {
        this.errorCallback = fn;
    }
    
    /** ----------------------------------------
        Highlight/unhighlight errors
     ---------------------------------------- */

    _highlightErrors() {
        Object.keys(this.errorData.errors).forEach(key => {
            const skip = [];
            [...this.fields].forEach(fieldNode => {
                const name = this.normalizeFieldName(fieldNode.name);
                if (name === key && !skip.includes(key)) {
                    if (fieldNode.type === 'radio') {
                        skip.push(key);
                        this._addErrorMessage(fieldNode, this.errorData.errors[key]);
                    } else {
                        fieldNode.classList.add('required');
                        this._addErrorMessage(fieldNode, this.errorData.errors[key]);
                    }
                }
            });
        });
    }

    _unhighlightErrors() {
        [...this.fields].forEach(fieldNode => {
            fieldNode.classList.remove('required');
            this._deleteErrorMessage(fieldNode);
        });
    }

    /** ----------------------------------------
        Add/remove messages
     ---------------------------------------- */

    _addSuccessMessage() {
        this.el.innerHTML = `
            <div class="success-block">
                <h4 class="success-block__text">${ this.successData }</h4>
            </div>
        `;
    }

    _addErrorMessage(fieldNode, message) {
        const errorNode = document.createElement('div');
        errorNode.innerHTML = message;
        errorNode.className = this.errorClass;
        fieldNode.errorNode = errorNode;

        if (fieldNode.type === 'radio') {
            fieldNode.parentNode.parentNode.appendChild(errorNode);
        } else if (fieldNode.type === 'checkbox') {
            fieldNode.parentNode.insertBefore(errorNode, fieldNode.nextElementSibling.nextSibling);
        } else {
            fieldNode.parentNode.insertBefore(errorNode, fieldNode.nextSibling);
        }
    }

    _deleteErrorMessage(fieldNode) {
        if (!fieldNode.errorNode) return;

        fieldNode.errorNode.parentNode.removeChild(fieldNode.errorNode);
        delete fieldNode.errorNode;
    }

    /** ----------------------------------------
        processing submit
     ---------------------------------------- */

    _processingSubmit() {
        this._unhighlightErrors();
        this._setFieldsDisabledState(true);
        this._setButtonDisabledState(true);
    }

    /** ----------------------------------------
        Set fields disabled state
     ---------------------------------------- */

    _setFieldsDisabledState(state) {
        [...this.fields].forEach(fieldNode => {
            fieldNode.disabled = state;
        });
    }

    /** ----------------------------------------
        Set buttons disabled state
     ---------------------------------------- */

    _setButtonDisabledState(state) {
        [...this.buttons].forEach(buttonNode => {
            if (!buttonNode.originalText) buttonNode.originalText = buttonNode.innerHTML;

            buttonNode.disabled = state;
            buttonNode.innerHTML = (state) ? 'Versturen...' : buttonNode.originalText;
        });
    }

    /** ----------------------------------------
        Call Endpoint
     ---------------------------------------- */

    _callEndoint(data) {
        axios.post(this.url, data)
            .then(response => {
                this._handleSuccess(response);
            })
            .catch(error => {
                this._handleError(error);
            });
    }

    /** ----------------------------------------
        handle responses
     ---------------------------------------- */

    _handleSuccess(response) {
        if(!response.data) return;

        this.successData = response.data;

        this._setFieldsDisabledState(false);
        this._setButtonDisabledState(false);
        this._addSuccessMessage();

        if (this.successCallback)
            this.successCallback(this.successData);
    }

    _handleError(error) {
        if (!error.response) return;

        this.errorData = error.response.data;

        this._setFieldsDisabledState(false);
        this._setButtonDisabledState(false);
        this._highlightErrors();

        if (this.errorCallback)
            this.errorCallback(this.errorData);
    }

    /** ----------------------------------------
        File Event
     ---------------------------------------- */

    addFileEvent() {
        if (!this.fileInputEl) return;

        this.fileInputEl.addEventListener('change', (e) => {
            if (!e.target.files) return;

            this.fileSize = 0;

            [...e.target.files].forEach(file => {
                this.fileSize+= file.size;
            });

            this.fileErrorEl.style.display = (this.fileSize > this.maxFileSize * 1024 * 1024) ? 'block' : 'none';
        });
    }

    /** ----------------------------------------
        Add Submit Event
     ---------------------------------------- */

    addSubmitEvent() {
        grecaptcha.ready(() => {
            this.el.addEventListener('submit', (e) => {
                const data = new FormData(e.target);

                e.preventDefault();

                if (this.fileSize > this.maxFileSize * 1024 * 1024)
                    e.stopPropagation();
                
                this._processingSubmit();

                grecaptcha.execute(this.key, { action: this.action }).then(token => {
                    data.set('_recaptcha', token);
                    this._callEndoint(data);
                });
            });
        });
    }

    /** ----------------------------------------
        Helpers
     ---------------------------------------- */

    normalizeFieldName(name) {
        return name.replace(']', '').replace('[', '.');
    }

    /** ----------------------------------------
        Init
     ---------------------------------------- */

    init() {
        if(!this.action || !this.key)
            return;

        this.addFileEvent();
        this.addSubmitEvent();
    }
}